// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {setPlace} from './setPlace'
import {setPlaceList} from './setPlaceList'
import {setPagination} from './setPagination'

export const placeActions = {
  setPlace,
  setPlaceList,
  setPagination,
}
